import * as React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import { Avatar, Typography } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import HubIcon from "@mui/icons-material/Hub";
import "./style.css";
import { Link as RouterLink } from "react-router-dom";
import { navMenu } from "../helpers/constant";
import { useAppSelector } from "../helpers/hooks";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const Footer = () => {
  const user = useAppSelector((state) => state.userProfile.profile);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [activeMenu, setActiveMenu] = React.useState<string | null>(null);


  const handleOpenMenu = (
    event: React.MouseEvent<HTMLElement>,
    title: string
  ) => {
    setAnchorEl(event.currentTarget);
    setActiveMenu(title);
  };
  
  const handleCloseMenu = () => {
    setAnchorEl(null);
    setActiveMenu(null);
  };


  return (
    <React.Fragment>
      <Container
        className="dark-bg-footer footer-navigation"
        disableGutters
        maxWidth={false}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Grid py={3} px={"5%"} container rowSpacing={1}>
            <Grid
              size={{ md: 6, lg: 6, xs: 8, sm: 6 }}
              sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center", gap: 2 }}
            >
              <Avatar
                className="logo-footer"
                src={require("../static/images/logo-benz.png")}
                alt="m-logo"
              />
              <Avatar
                className="logo-watermark-footer"
                src={require("../static/images/benz-watermark.png")}
                alt="watermark-logo"
              />
            </Grid>
            <Grid
              size={{ md: 6, lg: 6, xs: 12, sm: 12 }}
              display={"flex"}
              justifyContent={"right"}
              sx={{ marginTop: "16px" }}
            >
             {navMenu.map((page) => {

                // if (page.title === "Dashboard" && user?.userType !== "ADMIN") {
                //   return null;
                // }
                if (page.title === "Manage Events" && user?.userType !== "ADMIN") return null;
  
                if (page.children) {
                  return (
                    <Box key={page.title} sx={{ position: "relative", pl: 2 }}>
                      <Typography
                        className="footer-menu"
                        sx={{
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                        }}
                        onClick={(e) => handleOpenMenu(e, page.title)}
                      >
                        {page.title}
                        {activeMenu === page.title ? (
                          <KeyboardArrowUpIcon fontSize="small" />
                        ) : (
                          <KeyboardArrowDownIcon fontSize="small" />
                        )}
                      </Typography>

                      <Menu
                        anchorEl={anchorEl}
                        open={activeMenu === page.title}
                        onClose={handleCloseMenu}
                        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                        transformOrigin={{ vertical: "top", horizontal: "center" }}
                      >
                        {page.children.map((child) => (
                          <MenuItem
                            key={child.link}
                            component={RouterLink}
                            to={child.link}
                            onClick={handleCloseMenu}
                          >
                            {child.title}
                          </MenuItem>
                        ))}
                      </Menu>
                    </Box>
                  );
                }


                return (
                  <Typography
                    key={page.link}
                    className="footer-menu"
                    component={RouterLink}
                    to={page.link}
                    variant="body1"
                    pl={2}
                  >
                    {page.title}
                  </Typography>
                );
              })}

            </Grid>
          </Grid>
        </Box>
      </Container>
      <Container className="light-bg footer-copyright-links">
        <Box sx={{ flexGrow: 1 }}>
          <Grid
            pt={4}
            pb={4}
            justifyContent="center"
            alignItems="center"
            container
            rowSpacing={1}
          >
            <Grid size={8}>
              <Copyright />
            </Grid>
            <Grid size={4} sx={{ display: "flex" }} justifyContent="right">
              <Typography
                variant="h6"
                color="#000"
                sx={{
                  fontSize: "1.125rem",
                  fontWeight: "500!important",
                  lineHeight: "40px",
                }}
              >
                Contact Us
              </Typography>

              <EmailIcon
                color="primary"
                onClick={() =>
                  (window.location.href = `mailto:csr-mbrdi@mercedes-benz.com`)
                }
                className="icon mail-icon"
              />
              <a
                target="_blank"
                href="https://social.cloud.corpintra.net/groups/csr-mbrdi/"
              >
                <HubIcon color="primary" className="icon hub-icon" />
              </a>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </React.Fragment>
  );
};

function Copyright() {
  return (
    <Typography variant="body2" color="#000" align="left">
      {"© "}
      {new Date().getFullYear()}
      {
        ". Mercedes-Benz Research and Development India Pvt. Ltd. All Rights Reserved."
      }
    </Typography>
  );
}
export default Footer;
